import { FC } from 'react';

import NavigationOverlay from './NavigationOverlay';
import { useVideoPlayerContext } from '../contexts/VideoPlayerContext';

export const VideoNavigationOverlay: FC = () => {
    const { playVideo, pauseVideo } = useVideoPlayerContext();

    return <NavigationOverlay onPlay={playVideo} onPause={pauseVideo} />;
};
